import { useQuery } from '@apollo/client'
import { GetStatesForCountryQuery } from '../graphql/shipping-method.graphql'
import { ShippingCountry, ShippingState } from '../type/shipping-method'

export function useStatesForCountry(
  countryCode: string | null | undefined,
  countries: ShippingCountry[],
): ShippingState[] {
  const countryName = countryCode
    ? countries.find(c => c.code === countryCode)?.name
    : undefined

  const { data } = useQuery(GetStatesForCountryQuery, {
    variables: { country: countryName as string },
    skip: !countryName,
  })

  return data?.states ?? []
}
